import 'css-chunksrc/client/scenes/eventCreation/form/styles.scss';export default {
  "eventCreationForm": "_eventCreationForm_j9wb2_1",
  "projectSelectionRow": "_projectSelectionRow_j9wb2_8",
  "group": "_group_j9wb2_12",
  "title": "_title_j9wb2_21",
  "dateGroup": "_dateGroup_j9wb2_26",
  "listSelect": "_listSelect_j9wb2_35",
  "dateTimeInput": "_dateTimeInput_j9wb2_39",
  "row": "_row_j9wb2_43",
  "textArea": "_textArea_j9wb2_56",
  "descriptionTitle": "_descriptionTitle_j9wb2_60",
  "textInput": "_textInput_j9wb2_71",
  "checkbox": "_checkbox_j9wb2_75",
  "checked": "_checked_j9wb2_89",
  "selectAllDayBox": "_selectAllDayBox_j9wb2_106",
  "selectAllDayDescription": "_selectAllDayDescription_j9wb2_111"
};